import React from 'react';

import { Box, Typography } from 'components';

type Props = {
  header?: string;
  subHeader?: string;
  textAlignment?: 'center' | 'left' | 'right';
  icon?: React.ReactNode;
  image?: string;
  children?: React.ReactNode;
};
export const PageHeader: React.FC<Props> = ({
  header,
  subHeader,
  children,
  textAlignment,
  icon,
  image,
}) => {
  return (
    <Box zIndex={10} top={0} position="sticky" bgcolor="white">
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        gap="0.5rem"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
      >
        <Box display="flex" alignItems="center" gap="0.75rem" overflow="hidden">
          {icon && (
            <Box display="flex" alignItems="center" flexShrink={0}>
              {icon}
            </Box>
          )}
          {image && (
            <Box
              component="img"
              src={image}
              alt=""
              sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                objectFit: 'cover',
                flexShrink: 0,
              }}
            />
          )}
          <Box overflow="hidden">
            {header && (
              <Typography
                textAlign={textAlignment}
                variant="h2"
                noWrap
                sx={{
                  display: 'block',
                  maxWidth: '100%',
                }}
              >
                {header}
              </Typography>
            )}
            {subHeader && (
              <Typography
                textAlign={textAlignment}
                variant="subtitle1"
                noWrap
                sx={{
                  display: 'block',
                  maxWidth: '100%',
                  whiteSpace: 'normal',
                }}
              >
                {subHeader}
              </Typography>
            )}
          </Box>
        </Box>
        <Box width={{ xs: '100%', sm: 'auto' }} mt={{ xs: 1, sm: 0 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};
